import { formatPrice, getPrice } from 'utilities/content/content-utilities';
import { DeliveryAndReturnContentItem } from 'types/Product';

const getOnePersonHtml = (
  site: string | undefined,
  deliveryPrices: { type: string; value: number }[],
): DeliveryAndReturnContentItem => {
  const fallbackPricesVery: Record<string, number> = {
    STD: 3.99,
    NXT: 5.99,
    NOM: 5.99,
    CPL: 3,
    CPNXT: 4.99,
  };

  const fallbackPricesVeryIreland: Record<string, number> = {
    STD: 2.99,
    NXT: 4.99,
    EXP: 4.99,
    CPL: 0,
    CPNXT: 4.99,
  };

  const fallbackPricesLittlewoods: Record<string, number> = {
    STD: 0.0,
    NXT: 5.99,
    NOM: 5.99,
    CPL: 0.0,
    CPNXT: 3.99,
  };

  const content: DeliveryAndReturnContentItem = {
    pageText: 'Please select an option to view delivery options on this item',
    pageLink: '',
    modalHeading: '',
    modalBody: '',
  };

  if (site === 'very') {
    content.pageText =
      'FREE standard delivery with Click & Collect on orders £30 or more (product exclusions apply), and free returns.';
    content.pageLink = 'Find out more about Click & Collect';
    content.modalHeading = 'Delivery and Returns';
    content.modalBody = `
      <h3><strong>Delivery Options</strong></h3>
      <h4><strong>Click & Collect</strong></h4>
      <p>Orders will be delivered to one of 1,000s of pick-up points. Selected lines only, determined by size, weight, or whether delivered directly from one of our suppliers.</p>
      <ul>
        <li>Standard Delivery: FREE - on orders of £30 or more (${formatPrice(site, getPrice('CPL', fallbackPricesVery, deliveryPrices))} charge for orders under £30) - Expected delivery within 3-5 days.</li>
        <li>Next Day Delivery*: ${formatPrice(site, getPrice('CPNXT', fallbackPricesVery, deliveryPrices))} - Expected delivery the next working day.</li>
      </ul>
      <h4><strong>Home Delivery</strong></h4>
      <ul>
        <li>Standard Delivery: ${formatPrice(site, getPrice('STD', fallbackPricesVery, deliveryPrices))} - Expected delivery within 3-5 days.</li>
        <li>Next Day Delivery*: ${formatPrice(site, getPrice('NXT', fallbackPricesVery, deliveryPrices))} - Expected delivery the next working day.</li>
        <li>Nominated Day Delivery*: ${formatPrice(site, getPrice('NOM', fallbackPricesVery, deliveryPrices))} - Book delivery up to 10 days in advance.</li>
      </ul>
      <p>Delivery dates and charges will be calculated at checkout based on your order time and selection.</p>
      <p>All deliveries are made Monday to Saturday, between 7am and 9pm, excluding bank holidays.</p>
      <p>*Available for selected items.</p>
      <br>
      <h3><strong>Returns</strong></h3>
      <p>Returns are free under our 28 day approval guarantee. You can arrange a return through My Account.</p>
    `;
    return content;
  }

  if (site === 'veryie') {
    content.pageText =
      'FREE standard delivery with Click & Collect through Parcel Connect stores (product exclusions apply) and FREE returns.';
    content.pageLink = 'Find out more about Click & Collect';
    content.modalHeading = 'Delivery and Returns';
    content.modalBody = `
      <p>For all delivery services, you will be able to view your estimated delivery date at checkout. Please add your Eircode to your address in <a href="/account/login.page?from=/account/myaccount/accountSummary.page">My Account</a> to help us make sure your orders get delivered to the right place.</p>
      <h5><strong>FREE Standard Delivery with Click & Collect</strong></h5>
      <p>Orders will be delivered to one of over 1000 Parcel Connect stores.</p>
      <h5><strong>Click & Collect Express</strong></h5>
      <ul>
        <li>${formatPrice(site, getPrice('CPNXT', fallbackPricesVeryIreland, deliveryPrices))}</li>
        <li>Order by 10pm Sunday to Thursday</li>
        <li>Expected delivery: 1-2 working days (Monday to Friday) for products stocked in our warehouse and 4 working days for products despatched from a supplier's warehouse - view your estimated delivery date at checkout.</li>
      </ul>
      <h5><strong>Click & Collect Standard</strong></h5>
      <ul>
        <li>${formatPrice(site, getPrice('CPL', fallbackPricesVeryIreland, deliveryPrices))}</li>
        <li>Expected delivery: Within 4-7 working days (Monday to Friday).</li>
      </ul>
      <h5><strong>Standard delivery</strong></h5>
      <ul>
        <li>${formatPrice(site, getPrice('STD', fallbackPricesVeryIreland, deliveryPrices))}</li>
        <li>Usually delivered within 4-7 working days (Monday to Friday).</li>
      </ul>
      <h5><strong>Express delivery</strong></h5>
      <ul>
        <li>${formatPrice(site, getPrice('EXP', fallbackPricesVeryIreland, deliveryPrices))}</li>
        <li>Order by 10pm Sunday to Thursday</li>
        <li>Expected delivery: 1-2 working days (Monday to Friday) for products stocked in our warehouse and 4 working days for products despatched from a supplier's warehouse - view your estimated delivery date at checkout.</li>
      </ul>
      <h5><strong>Returns</strong></h5>
      <p>Returns are free under our 28 day approval guarantee. You can arrange a return through My Account.</p>
  `;

    return content;
  }
  if (site === 'littlewoods') {
    content.pageText = 'FREE standard delivery and returns';
    content.pageLink = 'Find out more about Click & Collect';
    content.modalHeading = 'Delivery and Returns';
    content.modalBody = `
      <h3><strong>Click & Collect delivery options</strong></h3>
      <h5><strong>Standard delivery</strong></h5>
      <ul>
        <li>${formatPrice(site, getPrice('STD', fallbackPricesLittlewoods, deliveryPrices))}</li>
        <li>Expected delivery: Usually within 3-5 days (excluding Sundays)</li>
      </ul>
      <h5><strong>Next day delivery</strong></h5>
      <h5><strong>(available on most small items)</strong></h5>
      <ul>
        <li>${formatPrice(site, getPrice('NXT', fallbackPricesLittlewoods, deliveryPrices))}</li>
        <li>Order by 10pm, Sun - Fri</li>
        <li>Expected delivery: Next day between 7am - 9pm Mon - Sat.</li>
      </ul>
      <p>Orders will be delivered to one of the 1000s of Yodel stores or Post Offices. Selected lines only, determined by size, weight or whether delivered direct from one of our suppliers.</p>
      <h3><strong>Home delivery options</strong></h3>
      <h5><strong>Standard delivery</strong></h5>
      <ul>
        <li>${formatPrice(site, getPrice('STD', fallbackPricesLittlewoods, deliveryPrices))}</li>
        <li>Expected delivery: Usually within 3-5 days (excluding Sundays)</li>
      </ul>
      <h5><strong>Next day delivery</strong></h5>
      <h5><strong>(available on most small items)</strong></h5>
      <ul>
        <li>${formatPrice(site, getPrice('NXT', fallbackPricesLittlewoods, deliveryPrices))}</li>
        <li>Order by 10pm, Sun - Fri</li>
        <li>Expected delivery: Next day between 7am - 9pm Mon - Sat.</li>
      </ul>
      <h5><strong>Nominated day delivery</strong></h5>
      <h5><strong>(available on most small items)</strong></h5>
      <ul>
        <li>${formatPrice(site, getPrice('NOM', fallbackPricesLittlewoods, deliveryPrices))}</li>
        <li>Book delivery up to 10 days in advance</li>
        <li>Expected delivery: Next day between 7am - 9pm Mon - Sat.</li>
      </ul>
       <h3><strong>Returns</strong></h3>
       <p>Returns are free and easy under our 28 day home approval guarantee using the following services:</p>
       <ul class="vpd-lw-delivery-return-list">
          <li><strong>Return your item at your local Yodel store</strong></li>
          <li><strong>Return item through your local Post Office*</strong></li>
        </ul>
        <p>For large and bulky items please call our customer service team on 0800 600 400</p>
        <p>*Maximum weight 10kg</p>
  `;

    return content;
  }
  return content;
};

export default getOnePersonHtml;
